import AxiosUtils from "utils/axios-utils"
import { API } from "./api-route"
import { notification } from "antd";
import { SERVER_FILE_ENDPOINT } from "constants/envs";

export const uploadFileFormData = async (file: any) => {
    try {
        const postFormData = new FormData();
        postFormData.append('attachment', file);
        // Override the default 'application/json' header so axios sends the FormData as
        // multipart/form-data (with boundary). Otherwise axios serializes the File to {} via JSON.
        const res: any = await AxiosUtils.post(API.uploadFile, postFormData, {
            'Content-Type': 'multipart/form-data',
        });
        return res.data
    } catch (error) {
        notification.error({ message: 'Error', description: 'Something went wrong!', duration: 4 });
    }
}